<template>
  <div class="md:flex flex-row p-5 container mx-auto">
    <div class="lg:w-1/4 md:1/4 sm:w-full pr-3">
      <h2 class="uppercase font-medium text-xl border-b-2 border-teal-400">
        homeface
      </h2>
      <ul class="pt-2">
        <li>
          <a href="#search" class="text-teal-400 text-sm">Suche</a>
        </li>
        <li>
          <router-link
            to="/impressum"
            class="text-teal-400 text-sm"
            target="_blank"
            >Impressum</router-link
          >
        </li>
      </ul>
    </div>
    <div class="lg:w-1/4 md:1/4 sm:w-full pr-3">
      <h2 class="uppercase font-medium text-xl border-b-2 border-teal-400">
        kundenservice
      </h2>
      <ul class="pt-2">
        <li>
          <router-link
            to="/agb"
            class="uppercase text-teal-400 text-sm"
            target="_blank"
            >agb</router-link
          >
        </li>
        <li>
          <router-link to="/daten" class="text-teal-400 text-sm" target="_blank"
            >Datenschutzerklärung</router-link
          >
        </li>
        <li>
          <router-link to="/widerrufsrecht" class="text-teal-400 text-sm" target="_blank"
            >Widerrufsrecht</router-link
          >
        </li>
      </ul>
    </div>
    <div class="lg:w-1/4 md:1/4 sm:w-full pr-3">
      <h2 class="uppercase font-medium text-xl border-b-2 border-teal-400">
        Zahlungsmethoden
      </h2>
      <ul class="cards p-2">
        <li class="flex text-sm  p-1">
          <img src="@/assets/images/Paypal.jpg" class="w-8 h-6" alt="paypal" />
          <span class="pl-2">PayPal</span>
        </li>
        <li class="flex text-sm p-1">
          <img src="@/assets/images/Visa.jpg" alt="visa" class="w-8 h-6" />
          <span class="pl-2">Visa</span>
        </li>
        <li class="flex text-sm p-1">
          <img
            src="@/assets/images/Mastercard.jpg"
            alt="mastercard"
            class="w-8 h-6"
          />
          <span class="pl-2">Master Card</span>
        </li>
      </ul>
    </div>
    <div class="lg:w-1/4 md:1/4 sm:w-full pr-3">
      <h2 class="uppercase font-medium text-xl border-b-2 border-teal-400">
        Versand
      </h2>
      <ul class="pt-2">
        <li class="text-sm">
          <img src="@/assets/images/Hermes.jpg" alt="hermes" class="w-24" />
        </li>
      </ul>
    </div>
    <div class="lg:w-1/4 md:1/4 sm:w-full pr-3">
      <h2 class="uppercase font-medium text-xl border-b-2 border-teal-400">
        kontakt
      </h2>
      <ul class="pt-2">
        <li class="text-sm">Adresse: Homeface GmbH</li>
        <li class="text-sm">Weddigenufer 2</li>
        <li class="text-sm">32052 Herford</li>
        <li class="text-sm">Deutschland</li>
        <li class="text-sm">
          Tel:
          <a href="tel:+4915792366917" class="text-teal-400 text-sm"
            >+49 1579-2366917</a
          >
        </li>
        <li class="text-sm">
          E-mail:
          <a href="mailto:info@homeface.de" class="text-teal-400 text-sm"
            >info@homeface.de</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>

/* @media(max-width:450px){
  .cards{
    display: flex;
    gap: 2px;
  
  }
} */

/* @media (min-width: 375px) and (max-width: 450px) {
  .cards {
    display: flex;
    gap: 4px;
    justify-content: center;
  }
} */

@media (min-width: 356px) and (max-width: 450px) {
  .cards {
    display: flex;
    gap: 2px;
    justify-content: center;
  }
}

</style>
